import {createContext, useContext, useMemo, useState} from "react";

export interface IMainMenuContext {
    selectedGroup?: string;
    setSelectedGroup?: (group: string) => void;
}

export interface IMainMenuWithContext {
    children: any,
}

const MainMenuContext = createContext<IMainMenuContext>({});

export function MainMenuWithContext({children}: IMainMenuWithContext) {
    const [selectedGroup, setSelectedGroup] = useState(null);

    const state: IMainMenuContext = useMemo(() => ({
        selectedGroup,
        setSelectedGroup,
    }), [selectedGroup]);

    return (
        <MainMenuContext.Provider value={state}>
            {children}
        </MainMenuContext.Provider>
    )
}

export function useMainMenuContext() {
    return useContext(MainMenuContext);
}
